import { stringToSVG } from '../../../utilities';

const svg = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_archive_file)">
<path d="M27.5 5V10H32.5" stroke="black" stroke-width="1.5"/>
<path d="M32.5 10L27.5 5H7.5V35H32.5V10Z" stroke="#2E3138" stroke-width="1.5"/>
<path d="M20 11V13" stroke="#2E3138" stroke-width="1.5" stroke-linecap="round"/>
<path d="M20 15V17" stroke="#2E3138" stroke-width="1.5" stroke-linecap="round"/>
<path d="M20 19V21" stroke="#2E3138" stroke-width="1.5" stroke-linecap="round"/>
<path d="M20 23V25" stroke="#2E3138" stroke-width="1.5" stroke-linecap="round"/>
<rect x="17" y="25" width="6" height="7" rx="1" stroke="#2E3138" stroke-width="1.5"/>
</g>
<defs>
<clipPath id="clip0_archive_file">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>`;

export default stringToSVG(svg);
